import { Component } from '@angular/core';

@Component({
  selector: 'app-sub-layout',
  templateUrl: './sub-layout.component.html',
  styleUrl: './sub-layout.component.scss',
  standalone: false
})
export class SubLayoutComponent {

}
